import React from 'react';
import PropTypes from 'prop-types';

import ActivityStatCard from '../NewStatsTabContent/ActivityStats/ActivityStatCard';
import styles from './activityStatsTeaser.scss';
import { activityStatsSportKeys } from '../../../utils/constants';

function SportsSectionContent({ sportKey, badgeClassName, stat, showMatchesPlayedHeader, matchesPlayedHeader }) {
    const isPickleball = sportKey === activityStatsSportKeys.PICKLEBALL;
    const badgeLabel = isPickleball ? 'Pickleball' : 'Tennis';
    return (
        <div className={styles.sportBlock}>
            {showMatchesPlayedHeader && (
                <div className={styles.grayBar}>{matchesPlayedHeader}</div>
            )}
            <div className={styles.sportBody}>
                <div className={badgeClassName}>
                    {badgeLabel}
                </div>
                <div className={styles.statCardWrap}>
                    <div className={styles.statCardInner}>
                        <ActivityStatCard
                            teaser
                            hideStatHeader
                            title={stat.title}
                            total={stat.total}
                            wins={stat.wins}
                            losses={stat.losses}
                            rankLabel={stat.rankLabel}
                            rank={stat.rank}
                            rankDisplay={stat.rankDisplay}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

SportsSectionContent.propTypes = {
    sportKey: PropTypes.string.isRequired,
    badgeClassName: PropTypes.string.isRequired,
    stat: PropTypes.shape({
        title: PropTypes.string,
        total: PropTypes.number,
        wins: PropTypes.number,
        losses: PropTypes.number,
        rankLabel: PropTypes.string,
        rank: PropTypes.number,
        rankDisplay: PropTypes.string,
    }).isRequired,
    showMatchesPlayedHeader: PropTypes.bool,
    matchesPlayedHeader: PropTypes.string,
};

SportsSectionContent.defaultProps = {
    showMatchesPlayedHeader: true,
    matchesPlayedHeader: 'Matches Played - All Time',
};

export default SportsSectionContent;
